export default __webpack_public_path__ + "static/media/emilyz.105ff23d.jpg";